import React from 'react'
import {graphql} from 'gatsby'
import LegalPageTemplate from '../../components/templates/legal/LegalPageTemplate'

const TermsPage = ({data}) => {
    return <LegalPageTemplate data={data} />
}

export const query = graphql`
  query TermsPageQuery($language: String = "en") {
    markdownRemark(
      frontmatter: {
        type: {eq: "terms"}
        language: {eq: $language}
      }
    ) {
      html
      frontmatter {
        title
        language
        type
        lastUpdated
      }
    }
  }
`

export default TermsPage
